import React from 'react'
import styled from 'styled-components'
import { ExclamationCircle } from '@styled-icons/heroicons-outline'
import { device } from '../../../../config/theme/breakpoints'

const ContainerAlert = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid #fea5003b;
  display: flex;
  flex-direction: column;

  @media ${device.mobileL}{
    flex-direction: row;
  }
`
const ContainerIcon = styled.div`
  background: #fea5003b;
  border-radius: 20px 20px 0 0;
  width: 100%;
  padding: 20px;
  display: flex;
  jutify-content: center;
  align-items: flex-start;

  > svg{
    max-width: 40px;
    color: ${p => p.theme.palette.primary.main};
  }

  @media ${device.mobileL}{
    max-width: 8%;
    border-radius: 18px 0 0 18px;
  }
`

const ContainerText = styled.div`
  padding: 10px 15px;
  background: #fea5003b;
  border-radius: 0 0 20px 20px;
  width: 100%;

  > h3{
    color: ${p => p.theme.palette.text.primary};
    text-align: center;

    @media ${device.mobileL}{
      text-align: left;
    }
  }

  > p{
    font-weight: 100;
    font-size: 12px;
  }

  @media ${device.tablet}{
    border-radius: 0 20px 20px 0;
  }
`

const AlertInfoAccount: React.FunctionComponent = () => {
  return (
    <ContainerAlert>
      <ContainerIcon>
        <ExclamationCircle />
      </ContainerIcon>
      <ContainerText>
        <p>
          Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum is simply dummy text of the Solicita tus millas pendientes 
        </p>
      </ContainerText>
    </ContainerAlert>
  )
}

export default AlertInfoAccount